module.exports = __webpack_public_path__ + "static/img/3.ee19638.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/3/sp/3.png
// module id = /mNb
// module chunks = 0